export type FieldCardValue = { value: string; count: number };

export function fieldCardView(card: Record<string, unknown>): {
  facts: string[];
  values: FieldCardValue[];
} {
  const enums = Array.isArray(card.enums) ? card.enums.map(String) : [];
  const counts = new Map<string, number>();
  for (const value of enums) counts.set(value, (counts.get(value) ?? 0) + 1);
  const units = Array.isArray(card.units) ? card.units.join(", ") : null;
  const facts = [
    card.source_field_id != null && `id ${card.source_field_id}`,
    typeof card.datatype === "string" && card.datatype,
    typeof card.required === "boolean" &&
      (card.required ? "required" : "optional"),
    typeof card.section === "string" && `section ${card.section}`,
    units && `units ${units}`,
    enums.length > 0 &&
      (counts.size < enums.length
        ? `${enums.length} values, ${counts.size} different`
        : `${enums.length} values`),
  ].filter((fact): fact is string => Boolean(fact));
  return {
    facts,
    values: Array.from(counts, ([value, count]) => ({ value, count })),
  };
}
